export default (app, bus) => {
  const globalProperties = app.config.globalProperties
  globalProperties.$bus = bus
}
